// Builds a slug -> image map from every .png in assets/images/categories
// so a category without a matching icon (e.g. a newly added brand) falls
// back to `undefined` instead of crashing the app with a webpack
// "Cannot find module" error at render time.
const categoryImageContext = require.context(
  "../assets/images/categories",
  false,
  /\.png$/
);

const categoryImageMap = categoryImageContext.keys().reduce((acc, key) => {
  const slug = key.replace("./", "").replace(".png", "");
  acc[slug] = categoryImageContext(key);
  return acc;
}, {});

export const getCategoryImage = (slug) => categoryImageMap[slug];
